import { useWindowSize } from "client/hooks/utils/useWindowSize";
import { RootState, useAppSelector } from "store/store";
import { useTextBox } from "../../../Preview/TextBox/useTextBox";

export const useTextBoxSettings = () => {
    const activeTextBoxId = useAppSelector(activeTextBoxIdSelector);
    const textBox = useAppSelector((state) =>
        state.memeGenerator.meme?.textBoxes.find((_t) => _t.id === activeTextBoxId),
    );
    const { handleOutsideClick } = useTextBox(textBox);
    const { width } = useWindowSize();
    return { activeTextBoxId, textBox, handleOutsideClick, width };
};

function activeTextBoxIdSelector(state: RootState) {
    return state.memeGenerator.meme?.activeTextBoxId;
}
